export default __webpack_public_path__ + "static/media/score-rick-flag.9bd969cc.png";